import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { FoldIcon } from "../../components/FoldIcon";
import "./styles.css";
import { MeetingIcon } from "../../components/MeetingIcon";

const MeetingEndPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const reloadPage = () => {
    document.getElementById("zmmtg-root")?.remove();
    const status = searchParams.get("status");
    if (!!status) {
      searchParams.delete("status");
      setSearchParams(searchParams);
      window.location.reload();
    }
  };

  useEffect(() => {
    reloadPage();
  }, []);

  return (
    <div className="container">
      <div className="sub-container">
        <div>
          <FoldIcon />
        </div>
        <div className="me-text-container">
          <h1 className="meeting-ended-text">Meeting Ended</h1>
        </div>
        <div>
          <MeetingIcon />
        </div>
      </div>
    </div>
  );
};

export default MeetingEndPage;
